import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import styles from "./Impressum.module.scss";

export default function Impressum() {
  useEffect(() => {
    document.title = "Impressum | Alex Rodriguez";
    window.scrollTo(0, 0);
  }, []);

  return (
    <main className={styles.legal}>
      <div className={styles.container}>
        <Link className={styles.back} to="/">
          ← Zurück zum Portfolio
        </Link>

        <h1 className={styles.title}>Impressum</h1>
        <p className={styles.updated}>Stand: September 2025</p>

        <h2 className={styles.sectionTitle}>Angaben gemäß § 5 TMG</h2>
        <address className={styles.address}>
          Alex Rodriguez
          <br />
          Quellenstraße 14
          <br />
          86165 Augsburg
          <br />
          Deutschland
        </address>

        <h2 className={styles.sectionTitle}>Kontakt</h2>
        <p className={styles.text}>
          Telefon:{" "}
          <a className={styles.link} href="tel:+491633833515">
            +49 163 3833515
          </a>
          <br />
          E-Mail:{" "}
          <a
            className={styles.link}
            href="mailto:alex.rodriguez.vera@hotmail.com"
          >
            alex.rodriguez.vera@hotmail.com
          </a>
        </p>

        <h2 className={styles.sectionTitle}>
          Verantwortlich für den Inhalt nach § 18 Abs. 2 MStV
        </h2>
        <p className={styles.text}>
          Alex Rodriguez
          <br />
          Quellenstraße 14
          <br />
          86165 Augsburg
          <br />
          Deutschland
        </p>

        <h2 className={styles.sectionTitle}>EU-Streitschlichtung</h2>
        <p className={styles.text}>
          Die Europäische Kommission stellt eine Plattform zur
          Online-Streitbeilegung (OS) bereit:{" "}
          <a
            className={styles.link}
            href="https://ec.europa.eu/consumers/odr/"
            target="_blank"
            rel="noopener noreferrer"
          >
            https://ec.europa.eu/consumers/odr/
          </a>
          .
          <br />
          Unsere E-Mail-Adresse finden Sie oben im Impressum.
        </p>

        <h2 className={styles.sectionTitle}>
          Verbraucherstreitbeilegung / Universalschlichtungsstelle
        </h2>
        <p className={styles.text}>
          Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren
          vor einer Verbraucherschlichtungsstelle teilzunehmen.
        </p>

        <h2 className={styles.sectionTitle}>Haftung für Inhalte</h2>
        <p className={styles.text}>
          Als Diensteanbieter sind wir gemäß § 7 Abs. 1 TMG für eigene Inhalte
          auf diesen Seiten nach den allgemeinen Gesetzen verantwortlich. Nach
          §§ 8 bis 10 TMG sind wir als Diensteanbieter jedoch nicht verpflichtet,
          übermittelte oder gespeicherte fremde Informationen zu überwachen oder
          nach Umständen zu forschen, die auf eine rechtswidrige Tätigkeit
          hinweisen.
        </p>
        <p className={styles.text}>
          Verpflichtungen zur Entfernung oder Sperrung der Nutzung von
          Informationen nach den allgemeinen Gesetzen bleiben hiervon unberührt.
          Eine diesbezügliche Haftung ist jedoch erst ab dem Zeitpunkt der
          Kenntnis einer konkreten Rechtsverletzung möglich. Bei Bekanntwerden
          von entsprechenden Rechtsverletzungen werden wir diese Inhalte
          umgehend entfernen.
        </p>

        <h2 className={styles.sectionTitle}>Haftung für Links</h2>
        <p className={styles.text}>
          Unser Angebot enthält Links zu externen Websites Dritter, auf deren
          Inhalte wir keinen Einfluss haben. Deshalb können wir für diese
          fremden Inhalte auch keine Gewähr übernehmen. Für die Inhalte der
          verlinkten Seiten ist stets der jeweilige Anbieter oder Betreiber der
          Seiten verantwortlich. Die verlinkten Seiten wurden zum Zeitpunkt der
          Verlinkung auf mögliche Rechtsverstöße überprüft. Rechtswidrige Inhalte
          waren zum Zeitpunkt der Verlinkung nicht erkennbar.
        </p>
        <p className={styles.text}>
          Eine permanente inhaltliche Kontrolle der verlinkten Seiten ist jedoch
          ohne konkrete Anhaltspunkte einer Rechtsverletzung nicht zumutbar. Bei
          Bekanntwerden von Rechtsverletzungen werden wir derartige Links
          umgehend entfernen.
        </p>

        <h2 className={styles.sectionTitle}>Urheberrecht</h2>
        <p className={styles.text}>
          Die durch den Seitenbetreiber erstellten Inhalte und Werke auf diesen
          Seiten unterliegen dem deutschen Urheberrecht. Die Vervielfältigung,
          Bearbeitung, Verbreitung und jede Art der Verwertung außerhalb der
          Grenzen des Urheberrechtes bedürfen der schriftlichen Zustimmung des
          jeweiligen Autors bzw. Erstellers. Downloads und Kopien dieser Seite
          sind nur für den privaten, nicht kommerziellen Gebrauch gestattet.
        </p>
        <p className={styles.text}>
          Soweit die Inhalte auf dieser Seite nicht vom Betreiber erstellt wurden,
          werden die Urheberrechte Dritter beachtet. Insbesondere werden Inhalte
          Dritter als solche gekennzeichnet. Sollten Sie trotzdem auf eine
          Urheberrechtsverletzung aufmerksam werden, bitten wir um einen
          entsprechenden Hinweis. Bei Bekanntwerden von Rechtsverletzungen
          werden wir derartige Inhalte umgehend entfernen.
        </p>

        <nav className={styles.nav} aria-label="Rechtliche Seiten">
          <Link to="/datenschutz">Datenschutzerklärung</Link>
          <Link to="/">Portfolio</Link>
        </nav>
      </div>
    </main>
  );
}
